var $ = require('jquery');

require('printthis');
require('webpack-jquery-ui/selectmenu');
import { post } from 'jquery';
import 'magnific-popup';

// $.urlParam = function(name){
//     var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
//     if (results == null){
//         return null; 
//     } else {
//         return decodeURI(results[1]) || 0;
//     }
// };

var loadMoreBtn = $('.load-more'),
	postsPerPage = 6;


$(document).ready(function () {
	videoPaused();

	initAjaxParameters();
	queryPosts();
	handleFilters();
});


$(window).on('load', function () {

});

$(document).ajaxComplete(function () {
	initAudioPopups();
	// externalLink();


});

// function newsFilter() {
// 	$('.news__triggers a').on('click', function (e) {
// 		e.preventDefault();
// 		var cat = $(this).data('cat');

// 		// console.log(cat);

// 		$('.news__triggers__item').removeClass('active');
// 		$(this).addClass('active');
// 		$('.section-news__posts .post').fadeOut(1);
// 		$('.section-news__posts ' + cat).fadeIn(200);

// 	});

// 	$('.news__select').selectmenu({
// 		change: function () {
// 			var cat = $(this).val();
// 			$(this).siblings().removeClass('active');
// 			$('.section-news__posts .post').fadeOut(1);
// 			$('.section-news__posts ' + cat).fadeIn(200);
// 		}
// 	});
// }

function initAudioPopups() {
	$('.post__audio-presentation').off('click').on('click', function (e) {
		e.preventDefault();

		const popup = $(this).next('.post__audio-presentation-popup');
		$.magnificPopup.open({
			items: {
				src: popup,
				type: 'inline'
			},
			removalDelay: 300,
			closeOnBgClick: false,
			mainClass: 'mfp-fade',
			showCloseBtn: false,
			closeBtnInside: false,
			callbacks: {
				open: function () {                        // When you open the
					$('body').addClass('no-scroll');
					var video = popup.find('video').get(0);
					video.play();

					$('html').css('overflow', 'hidden');
					$('html').css('margin-right', '17px');
				},                                        // "body" is used "overflow: hidden".
				beforeClose: function () {
					var video = popup.find('video').get(0);
					video.pause();
					$('html').removeAttr('style');
				}
			},
		});

		$('.post__audio-presentation-popup__close').off('click').on('click', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
	});
}

function videoPaused() {
	$("video").click(function () {
		var video = $(this).get(0);
		var videoContainer = $(this).parent();

		if (video.paused) {
			videoContainer.find(".play-icon").removeClass('hidden');
		} else {
			$(".play-icon").addClass('hidden');
		}

		return false;
	});
}

$.urlParam = function (name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	else {
		return decodeURI(results[1]) || 0;
	}
};


let parameters = {};
let postsXhr = null;

function renderPosts(response) {
	var postsWrapper = $('.section-news .posts');

	response.items.forEach(function (item) {
		postsWrapper.append(item);
	});

	loadMoreBtn.off('click').on('click', function (e) {
		e.preventDefault();
		if ($('.posts').hasClass('loaded-more-pages')) {
			parameters.load_pages = 'off';
		}
		parameters.page = parseInt(parameters.page) + 1;
		$(this).hide();
		queryPosts();
	});

}

function pushHistory() {
	let url = window.location.href.split('?')[0] + '?pag=' + parameters.page;
	if (parameters.filter) {
		url = url + '&filter=' + parameters.filter;
	} else {
		if (loadMoreBtn.length) {
			url = url + '&filter=' + loadMoreBtn.attr('data-category');
		} else {
			url = url + '&filter=all';
		}
	}

	window.history.pushState('next', document.title, url);
}

$(document).on({
	ajaxStart: function () {
		$('.ajax-loader').show();
	},
	ajaxStop: function () {
		$('.ajax-loader').hide();
	}
});

function queryPosts() {
	pushHistory();

	if (postsXhr) {
		postsXhr.abort();
	}

	postsXhr = $.post({
		url: ajax_params.ajaxurl,
		data: parameters,
		dataType: 'json',
		success: function (response) {
			renderPosts(response);

			if (parameters.page * postsPerPage >= response.total) {//hide load-more button when is last page
				loadMoreBtn.hide();
			} else {
				loadMoreBtn.fadeIn();
			}

			if (response.items.length < postsPerPage) {//hide load-more button when less than X posts on page when is applied a filter
				loadMoreBtn.hide();
			}

			if (response.items.length == 0) {//when returns 0 posts
				$('.section-news .posts').html('<div class="h2 inview-animate--fade inview-animate--move-up"><em>Sorry, no articles found!</em></div>');
			}
		},
		error: function () {
			console.log('Something went wrong!');
		}
	});
}


function initAjaxParameters() {
	parameters.action = 'load_posts';
	parameters.page = $.urlParam('pag') ? $.urlParam('pag') : 1;
	parameters.filter = $.urlParam('filter') ? $.urlParam('filter') : loadMoreBtn.attr('data-category');

	if (parameters.page > 1 && !$('.posts').hasClass('loaded-more-pages')) {//only for NEWS page
		$('.posts').addClass('loaded-more-pages');
		parameters.load_pages = 'on';
	}
}

function handleFilters() {
	var filterCategory = $('.section-news .news__triggers .news__triggers__item');

	filterCategory.removeClass('active');

	if (typeof parameters.filter == 'undefined') {
		$(".section-news .news__triggers .news__triggers__item[data-cat='all']").addClass('active')
	} else {
		$(".section-news .news__triggers .news__triggers__item[data-cat='" + parameters.filter + "']").addClass('active')
	}

	filterCategory.on('click', function (e) {
		e.preventDefault();
		filterCategory.removeClass('active');
		loadMoreBtn.hide();
		parameters.page = 1;
		parameters.filter = $(this).attr('data-cat');
		$(this).addClass('active');
		$('.section-news .posts').html('');
		queryPosts();
	});

	$('.news__select').selectmenu({
		open: function () {
			if (!$('.ui-menu .ui-menu-item').hasClass('active'))
				$('.ui-menu .ui-menu-item:first-child').addClass('active');
		},
		change: function (event, ui) {
			const cat = $(this).val();
			loadMoreBtn.hide();
			parameters.page = 1;
			parameters.filter = cat;
			$('.section-news .posts').html('');
			queryPosts();
			const menuId = $(this).attr('id') + '-menu'
			$(`#${menuId} .ui-menu-item`).removeClass('active');
			$(`#${menuId} .ui-menu-item:nth-child(${parseInt(ui.item.index) + 1})`).addClass('active')
			if ($(`#${menuId} .ui-menu-item:last-child`).hasClass('active')) {
				$(`#${menuId} .ui-menu-item:nth-last-child(2)`).addClass('border-none');
			} else {
				$(`#${menuId} .ui-menu-item`).removeClass('border-none')
			}
		}
	});
}


function externalLink() {
	var externalLink = $('a'),
		popupClose = $('.popup__close, .popup__cancel'),
		popupLink = $('.popup__link');

	externalLink.on('click', function (e) {
		if ($(this).attr('href').indexOf(window.location.href) != 0 && $(this).attr('href') != "#" && $(this).attr('href') != window.location.href) {
			if ($(this).attr('href').includes(window.location.origin) != true && !$(this).hasClass('no-interstitial-popup') && $(this).attr('href').includes('investors.nuvalent.com') != true) {
				e.preventDefault();
				$('.popup__link').attr('href', $(this).attr('href'));

				const popup = $('.external-popup');
				$.magnificPopup.open({
					items: {
						src: popup,
						type: 'inline'
					},
					removalDelay: 300,
					closeOnBgClick: false,
					mainClass: 'mfp-fade',
					showCloseBtn: false,
					closeBtnInside: false,
					callbacks: {
						open: function () {                        // When you open the
							$('body').addClass('no-scroll');
							$('html').css('overflow', 'hidden');
							$('html').css('margin-right', '17px');
						},                                        // "body" is used "overflow: hidden".
						beforeClose: function () {
							$('html').removeAttr('style');
						}
					},
				});
			}
		}
	});

	popupClose.on('click', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	})

	popupLink.on('click', function (e) {
		$.magnificPopup.close();
		window.open(popupLink.attr('href'), '_blank');
		$('.external-popup').removeClass('visible');
		$('body').removeAttr('style');
	})
}